module.exports = __webpack_public_path__ + "static/img/pc_1.a6f4bdd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/pc_1.png
// module id = AiyV
// module chunks = 0